/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React from 'react'
import { ShimmerBadge,
    ShimmerButton,
    ShimmerTitle,ShimmerThumbnail,ShimmerSectionHeader, ShimmerCircularImage, ShimmerText } from 'react-shimmer-effects'

export default function AddSubjectShimmer() {
    
    return (
        <div className=" opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block" id="tabs-institutionDetails" role="tabpanel" aria-labelledby="tabs-institutionDetails-tab">
            <div className=" w-[55%] pt-2">
                <div className="w-full">

                    <div className="flex mb-4">
                        
                        <div className="w-1/2 ml-4">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[150px]"/></p>
                                <p className="text-f2 font-normal text-[#031624] GSTIN-fileUploaded"><ShimmerThumbnail height={40} width={400} rounded /></p>
                            </div>
                        </div>
                        <div className="w-1/2 ml-4">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[150px]"/></p>
                                <p className="text-f2 font-normal text-[#031624] GSTIN-fileUploaded"><ShimmerThumbnail height={40} width={400} rounded /></p>
                            </div>
                        </div>
                        <div className="w-1/2 ml-4">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[150px]"/></p>
                                <p className="text-f2 font-normal text-[#031624] GSTIN-fileUploaded"><ShimmerThumbnail height={40} width={400} rounded /></p>
                            </div>
                        </div>
                    </div>
                    <div className="w-1/2 ml-4">
                        <div className="w-full">
                            <p className="text-2xl font-bold text-[#031624] mt-4"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[150px]"/></p>
                            <p className="text-f2 font-normal text-[#031624] GSTIN-fileUploaded"><ShimmerThumbnail height={130} width={1250} rounded /></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
